import { useEffect, useState } from 'react';
import type { TEventStats, TEventStatus } from '../../types/event';
import { eventStatus } from '../../services/event';
import PageBreadcrumb from '../../components/common/PageBreadCrumb';
import { useToggle } from '../../hooks/useToggle';
import PageMeta from '../../components/common/PageMeta';
import { useParams } from 'react-router';
import { EventStatusMetrics } from '../../components/event-status/metrics';
import CommonTable, { ColumnConfig } from '../../components/common/Table';
import { useSimplePagination } from '../../hooks/useSimplePagination';
import { PAGINATION_PER_PAGE } from '../../utils/constants';

const columns: ColumnConfig<TEventStatus>[] = [
  {
    key: 'id',
    header: '#',
  },
  {
    key: 'eventId',
    header: 'Event name',
    render: (item) => item.event.name,
  },
  {
    key: 'userId',
    header: 'User name',
    render: (item) => item.user?.name,
  },
  {
    key: 'user',
    header: 'User Email',
    render: (item) => item.user?.email,
  },
  {
    key: 'status',
    header: 'RSVP',
  },
];

const EventStatuses = () => {
  const [events, setEvents] = useState<TEventStatus[]>([]);
  const [stats, setStats] = useState<TEventStats>({ yes: 0, no: 0, maybe: 0 });

  const { state: isLoading, on: showLoader, off: hideLoader } = useToggle();

  const { id } = useParams() as { id: string };
  const { currentPage, totalPages, onPageChange, setTotalPages } =
    useSimplePagination();

  const fetchEvents = async () => {
    if (isLoading) return;
    showLoader();
    const res = await eventStatus(id, {
      params: {
        page: currentPage,
        limit: PAGINATION_PER_PAGE,
      },
    }).finally(() => {
      hideLoader();
    });
    setEvents(res.rows ?? []);
    setTotalPages(res.count);
    setStats(res.stats);
  };

  useEffect(() => {
    fetchEvents();
    // eslint-disable-next-line
  }, [currentPage]);

  return (
    <div>
      <PageMeta title="Events Status" description="List of events status" />
      <PageBreadcrumb
        pageTitle="Events Status"
        mainPageLink="/events"
        mainPageTitle="Events"
        showBackToParentButton
      />
      <EventStatusMetrics data={stats} isLoading={isLoading} />
      <CommonTable
        columns={columns}
        data={events}
        isLoading={isLoading}
        totalPages={totalPages}
        currentPage={currentPage}
        showPagination
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default EventStatuses;
